import styled from 'styled-components';

export const MapStoresModalContainer = styled.div`
  width: 100%;
  height: 100%;

  > div > div > div {
    overflow-x: visible;
  }
`;
